import type { ApprovalGroupLevel } from "@/types/entities/approval-groups";
import {
  Badge,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
} from "@elaniintc/goes-design-system";

const getLevelVariant = (
  level?: ApprovalGroupLevel,
):
  | "info"
  | "warning"
  | "disabled"
  | "action"
  | "success"
  | "danger"
  | "neutral" => {
  switch (level) {
    case "lider":
      return "success";
    case "senior":
      return "danger";
    case "medio":
      return "action";
    // case "medio":
    //   return "info";
    // case "junior":
    //   return "warning";
    default:
      return "neutral";
  }
};

const getLevelLabel = (level?: ApprovalGroupLevel): string => {
  switch (level) {
    case "lider":
      return "Líder";
    case "senior":
      return "Supervisor";
    case "medio":
      return "Técnico";
    // case "junior":
    //   return "Junior";
    default:
      return "Nivel";
  }
};

const UserLevelSelector = ({
  id,
  currentLevel,
  readOnly = false,
  leaderAlreadySelected,
  // supervisorAlreadySelected,
  onLevelChange,
}: {
  id: string;
  readOnly?: boolean;
  currentLevel?: ApprovalGroupLevel;
  leaderAlreadySelected: boolean;
  supervisorAlreadySelected: boolean;
  onLevelChange: (id: string, level: ApprovalGroupLevel) => void;
}) => {
  if (readOnly) {
    return (
      <Badge size="sm" variant={getLevelVariant(currentLevel)}>
        {getLevelLabel(currentLevel) || "Nivel"}
      </Badge>
    );
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Badge size="sm" variant={getLevelVariant(currentLevel)}>
          {getLevelLabel(currentLevel) || "Nivel"}
          <Icon type="far" name="angle-down" />
        </Badge>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-[93px] rounded-lg border-neutral-silent text-body font-normal p-2"
        side="bottom"
        align="end"
        sideOffset={4}
      >
        <DropdownMenuGroup>
          {leaderAlreadySelected && (
            <DropdownMenuItem
              className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
              onClick={() => onLevelChange(id, "lider")}
            >
              Líder
            </DropdownMenuItem>
          )}
          {/* {supervisorAlreadySelected && (
            <DropdownMenuItem
              className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
              onClick={() => onLevelChange(id, "senior")}
            >
              Supervisor
            </DropdownMenuItem>
          )} */}
          <DropdownMenuItem
            className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
            onClick={() => onLevelChange(id, "senior")}
          >
            Supervisor
          </DropdownMenuItem>
          <DropdownMenuItem
            className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
            onClick={() => onLevelChange(id, "medio")}
          >
            Técnico
          </DropdownMenuItem>
          {/* <DropdownMenuItem
            className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
            onClick={() => onLevelChange(id, "medio")}
          >
            Medio
          </DropdownMenuItem>
          <DropdownMenuItem
            className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
            onClick={() => onLevelChange(id, "junior")}
          >
            Junior
          </DropdownMenuItem> */}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export { UserLevelSelector };
